import React, { useState } from "react";
import { TextField, Card, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { styles } from "../theme/styles";
import { CustomButtonWhite } from "../components/CustomButtonWhite";
import { Creators } from "../store/ducks/users";
import { connect } from "react-redux";
import SnackBar from "../components/SnackBarCustom";
import { Creators as CreatorsConfig } from "../store/ducks/config";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const PassForm = (props) => {
  const [pass_anterior, setPassAnterior] = useState("");
  const [pass_nueva, setPassNueva] = useState("");
  const {
    userData,
    idNumber,
    token,
    changePassword,
    loading,
    message,
    clearMessage,
  } = props;
  const navigate = useNavigate();

  const { t } = useTranslation();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const dataUser = {
      idNumber: idNumber,
      currentPassword: pass_anterior,
      newPassword: pass_nueva,
    };
    await changePassword(token, dataUser);
  };

  useEffect(() => {
    if (message?.text === "Datos correctos") {
      // navigate("/home");
    }
  }, [message, navigate]);

  return (
    <>
      <Card style={styles.contenedorPassStyle} variant="outlined">
        <Typography
          variant="h4"
          justifyContent="center"
          color="white"
          style={styles.title}>
          Usuario:&nbsp;&nbsp;{idNumber}
        </Typography>
        <div style={styles.container}>
          <div style={styles.textin}>
            <p>Ingresa los siguientes campos</p> &nbsp;&nbsp;
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="icon icon-tabler icon-tabler-lock"
              width="36"
              height="36"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="#ffffff"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6z" />
              <path d="M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0" />
              <path d="M8 11v-4a4 4 0 1 1 8 0v4" />
            </svg>
          </div>
          <form onSubmit={handleSubmit} style={styles.form}>
            <TextField
              label={t("pass_anterior")}
              variant="filled"
              type="password"
              value={pass_anterior}
              onChange={(event) => setPassAnterior(event.target.value)}
              style={styles.textField}
            />
            <TextField
              label={t("pass_nueva")}
              variant="filled"
              type="password"
              value={pass_nueva}
              onChange={(event) => setPassNueva(event.target.value)}
              style={styles.textField}
            />

            {!loading ? (
              <CustomButtonWhite type="submit">
                {t("cambiar")}
              </CustomButtonWhite>
            ) : (
              <CircularProgress />
            )}
          </form>
        </div>
      </Card>
      {message ? (
        <>
          <SnackBar
            message={message.text}
            variant={message.type}
            open={message ? true : false}
            onClose={clearMessage}
            time={3000}
          />
        </>
      ) : null}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    menu: state.users.menu,
    userData: state.users.data,
    idNumber: state.users.idNumber,
    token: state.users.uid,
    loading: state.users.loading,
    message: state.config.message,
  };
};

const creators = {
  logout: Creators.logout,
  changePassword: Creators.changePassword,
  clearMessage: CreatorsConfig.clearMessage,
};

export default connect(mapStateToProps, creators)(PassForm);
